import { AlertErrorGradient } from '@/components/TransactionModule/Alerts/shared';

import { buttons } from '@/styles/buttons';
import { fontStyles } from '@/styles/typography';

import { AlertCircleIcon } from '@/ui/Icons/AlertCircleIcon';
import { Modal } from '@/ui/Modal';

type Props = {
  /** Whether the modal is open. */
  isOpen: boolean;
  /** Callback to close the modal. */
  onClose: () => void;
};

export const NoLiquiditySourceSelectedModal = ({ isOpen, onClose }: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="py-6 px-6 flex overflow-hidden flex-col items-center text-center gap-4 relative">
        <div className="px-8 flex flex-col gap-8">
          <AlertErrorGradient />
          <div className="w-16 h-16 items-center rounded-full flex m-auto mt-14 justify-center z-1 bg-primitive-basic-white text-token-red-700">
            <AlertCircleIcon className="size-5" />
          </div>
          <span className={fontStyles({ variant: 'H5' })}>No Liquidity Source Selected</span>
          <p className={fontStyles({ variant: 'BODY_MD', class: 'text-token-gray-900 mb-10' })}>
            To continue trading, select at least one Liquidity Source. For the best prices, we
            recommend keeping all selected.
          </p>
        </div>
        <button
          className={buttons({ size: 'large', shape: 'pill', color: 'black' })}
          onClick={onClose}
        >
          Ok
        </button>
      </div>
    </Modal>
  );
};
